<section class="content">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <ul class="breadcrumb breadcrumb-style ">
            <li class="breadcrumb-item">
              <h4 class="page-title">Union office</h4>
            </li>
            
          </ul>
        </div>
      </div>
    </div>
    <!-- <app-maser-page-header></app-maser-page-header> -->
    <div class="row">
      <div class="col" *ngIf="!this.unionOfficeService.is_display_union_office_register_component">
        <button mat-fab color="primary" (click)="registerUnionOffice()">
          <mat-icon aria-hidden="false" aria-label="Example home icon">add</mat-icon>
        </button>
        <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" style="width: 100%;">
          <ng-container matColumnDef="id">
            <th style="background: #97cdef;" mat-header-cell *matHeaderCellDef mat-sort-header> ID</th>
            <td mat-cell *matCellDef="let element;let i = index"> {{i+1}}</td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th style="background: #97cdef;" mat-header-cell *matHeaderCellDef mat-sort-header > Name</th>
            <td mat-cell *matCellDef="let element">
              <div class="row">
                <div class="col">
                  {{element.name}}
                </div>

              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="union">
            <th style="background: #97cdef;" mat-header-cell *matHeaderCellDef mat-sort-header>Union</th>
            <td mat-cell *matCellDef="let element">
              <div class="row">
                <div class="col">
                  {{element.union}}
                </div>

              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="street">
            <th style="background: #97cdef;" mat-header-cell *matHeaderCellDef mat-sort-header>Street</th>
            <td mat-cell *matCellDef="let element">
              <div class="row">
                <div class="col">
                  {{element.street}}
                </div>

              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="address">
            <th style="background: #97cdef;" mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
            <td mat-cell *matCellDef="let element">
              <div class="row">
                <div class="col">
                  {{element.address}}
                </div>

              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="taluk">
            <th style="background: #97cdef;" mat-header-cell *matHeaderCellDef mat-sort-header>Taluk</th>
            <td mat-cell *matCellDef="let element">
              <div class="row">
                <div class="col">
                  {{element.taluk}}
                </div>

              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="district">
            <th style="background: #97cdef;" mat-header-cell *matHeaderCellDef mat-sort-header>District</th>
            <td mat-cell *matCellDef="let element">
              <div class="row">
                <div class="col">
                  {{element.district}}
                </div>

              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="mobile">
            <th style="background: #97cdef;" mat-header-cell *matHeaderCellDef mat-sort-header>Mobile</th>
            <td mat-cell *matCellDef="let element">
              <div class="row">
                <div class="col">
                  {{element.mobile}}
                </div>
                <div class="col" style="cursor: pointer;">
                  <mat-icon (click)="editUnionOffice(element)">edit</mat-icon>
                </div>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
      <div class="col-5" *ngIf="this.unionOfficeService.is_display_union_office_register_component">
        <div class="row">
          <div class="col"></div>
          <div class="col-1">
            <button mat-fab color="primary" (click)="hideUnionOfficeRegister()">
              <i class="material-icons">
                clear
              </i>
            </button>
          </div>
        </div>
        <app-union-office-register></app-union-office-register>
      </div>
    </div>
  </div>
</section>